import { render, staticRenderFns } from "./LqsSchedule.vue?vue&type=template&id=72126f36&scoped=true"
import script from "./LqsSchedule.vue?vue&type=script&lang=js"
export * from "./LqsSchedule.vue?vue&type=script&lang=js"
import style0 from "./LqsSchedule.vue?vue&type=style&index=0&id=72126f36&prod&scoped=true&lang=css"
import style1 from "./LqsSchedule.vue?vue&type=style&index=1&id=72126f36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72126f36",
  null
  
)

export default component.exports